import { useTranslation } from '@pancakeswap/localization'

export const MaxButton = ({ onMax }: { onMax: (() => void) | undefined }) => {
  const { t } = useTranslation()

  return (
    <button
      className={'text-xs cursor-pointer text-primary'}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        onMax?.()
      }}
      type="button"
    >
      {t('MAX')}
    </button>
  )
}
